<template>
    <section class="panelsContainer">
        <BaseProgressCircular v-bind:visible="showLoading"></BaseProgressCircular>
        <BaseConfirmDialog ref="baseConfirmDialog"></BaseConfirmDialog>
        <div class="mb-10">
            <BaseExpansionPanels v-bind:items="expansionPanelItems" v-on:cancel="onOpenDialog"></BaseExpansionPanels>
        </div>
        <div class="btn-container">
            <v-btn class="text-none" dark color="#C4170C" to="/">Voltar</v-btn>
        </div>
    </section>
</template>

<script>
import BaseExpansionPanels from './BaseExpansionPanels.vue'
import BaseConfirmDialog from './BaseConfirmDialog'
import BaseProgressCircular from './BaseProgressCircular'
import AgendamentoRepository from "@/repository/AgendamentoRepository"
import dateMixin from "../utils/mixins/date"
import addressMixin from "../utils/mixins/address"
import moment from "moment";

export default {
    name:'SchedulePanels',
    props:{
        protocol:{
            type:String
        },
        cpf:{
            type:String
        },
        cellphone:{
            type:String
        }
    },
    data: () => ({
        showLoading:false,
        expansionPanelItems: []
    }),
    created:function(){
        this.initializeSchedulesData()
    },
    methods:{
        initializeSchedulesData:async function(){
            this.showLoading = true
            if(this.cellphone === 'null'){
                this.cellphone = null
            }
            if(this.cpf === 'null'){
                this.cpf = null
            }
            if(this.protocol === 'null'){
                this.protocol = null
            }
            const rawSchedulesData = await AgendamentoRepository.getUserSchedules(this.protocol,this.cpf,this.cellphone)

            if(rawSchedulesData && rawSchedulesData.total > 0){
                const scheduleObjects = this.mountScheduleObjects(rawSchedulesData.dados)
                this.expansionPanelItems = this.mountExpansionPanelData(scheduleObjects)
                this.showLoading = false
            }
            else{
                this.showLoading = false
                this.$swal({
                    html: "Não foi possível encontrar nenhum agendamento com os dados fornecidos",
                    icon: "error"
                })
                .then(() => {this.onRedirect()})
            } 
        },
        mountScheduleObjects:function(rawSchedulesData){
            const scheduleObjects = []
            rawSchedulesData.forEach(schedule => {
                const poloAddress = this.getFullAddress(schedule.endereco_polo_logradouro, schedule.endereco_polo_numero, schedule.endereco_polo_complemento, schedule.endereco_polo_bairro, schedule.ponto_referencia)
                const localDate = new Date(schedule.agendamento_data_hora)
                const date = this.getFormatedDate(localDate)
                const hour = this.getFormatedHour(localDate)
                const canCancel = this.isScheduleCancellable(schedule)

                let scheduleObject = this.scheduleFactory(
                    schedule.servico_nome,
                    schedule.agendamento_protocolo,
                    schedule.polo_nome,
                    schedule.situacao_nome,
                    poloAddress,
                    date,
                    hour,
                    canCancel)
                scheduleObjects.push(scheduleObject)
            })
            return scheduleObjects
        },
        scheduleFactory:function(name, protocol, poloName, situation, poloAddress, date, hour, canCancel){
            return {
                name,
                protocol,
                poloName,
                situation,
                poloAddress,
                date,
                hour,
                canCancel,
                getDescription:function(){
                    return `${this.name} - Data: ${this.date} - Horário: ${this.hour}`
                }
            }
        },
        mountExpansionPanelData(scheduleObjects){
            const expansionPanelItems = []
            scheduleObjects.forEach(schedule => {
                expansionPanelItems.push(
                    {
                        title: schedule.getDescription(),
                        rows: [
                            {
                                columns:[
                                    {
                                        title: 'Polo de atendimento',
                                        content: schedule.poloName
                                    },
                                    {
                                        title:'Protocolo',
                                        content:schedule.protocol
                                    }
                                ]
                            },
                            {
                                columns:[
                                    {
                                        title:'Data',
                                        content:schedule.date
                                    },
                                    {
                                        title:'Horário',
                                        content:schedule.hour
                                    }
                                ]
                            },
                            {
                                columns:[
                                    {
                                        title:'Endereço',
                                        content:schedule.poloAddress
                                    },
                                    {
                                        title:'Situação',
                                        content:schedule.situation
                                    }
                                ]
                            }
                        ],
                        actions:[
                            {
                                name:'Cancelar serviço',
                                eventName:'cancel',
                                disabled: schedule.canCancel ? false : true,
                                dataToReturn: schedule
                            }
                        ]
                    }
                )
            })
            return expansionPanelItems
        },
        isScheduleCancellable:function(rawSchedule){
            const scheduleDate = new Date(rawSchedule.agendamento_data_hora)
            if(moment(scheduleDate).isBefore(moment(new Date())) || rawSchedule.situacao_nome === "Cancelado"){
                return false
            }
            else{
                return true
            } 
        },
        onOpenDialog:function(item){
            this.$refs.baseConfirmDialog.showConfirm("Aviso","Tem certeza que deseja cancelar este serviço ? Ao cancelar você perderá sua vaga no dia, tendo assim que reagendar para outro dia e horário")
            .then(
                (result) => {
                    if(result === true){
                        this.onCancelSchedule(item)
                    }
                }
            )
        },
        onCancelSchedule:async function(item){
            this.showLoading = true
            const response = await AgendamentoRepository.cancelSchedule(item.protocol)
            this.showLoading= false
            if(response){
                item.canCancel = false
                this.$swal({
                    html:response,
                    icon:"success"
                }).then(() => {
                    this.initializeSchedulesData()
                })
            }
            else{
                this.$swal({
                    html:"Não foi possível cancelar o agendamento",
                    icon:"error"
                })
            }
        },
        onRedirect:function(){
            this.$router.push('/consultar-agendamento');
        }
    },
    mixins:[dateMixin, addressMixin],
    components:{BaseExpansionPanels,BaseConfirmDialog,BaseProgressCircular}
}
</script>

<style scoped>
    .panelsContainer{
        position: relative;
        padding: 20px;
        min-height: 100%;
    }
    .btn-container{
        position: absolute;
        bottom: 5px;
        left: 20px;
    }

    .mb-10{
        margin-bottom: 10px;
    }
</style>